import * as React from 'react';
import { connect } from 'react-redux';
import { navigateTo } from '../../../actions/navigationActions';
import '../PolicyDetails/PolicyDetails.css';
import QuotedItemDetail from './QuotedItemDetail';

class QuoteDetails extends React.Component<any, any> {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    public render() {
        return (
            <QuotedItemDetail />
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(QuoteDetails);